import { useEffect, useState } from "react";
import Select from "react-select";
import styled from "styled-components";

import { useTranslation } from "react-i18next";
import { request } from "../../utils/axios-utils";
import FirstGroup from "./ChartGroups/FirstGroup";
import ThirdGroup from "./ChartGroups/ThirdGroup";
import SixthGroup from "./ChartGroups/SixthGroup";
import { DataResponse } from "../../types/types";
import { useLocation } from "react-router-dom";
import { timeDataEn, timeDataRu } from "../../utils/constants";
import { Loader } from "../UI/Loader";

interface DashboardProps {
  data?: any;
  response?: any;
  refetch?: () => void;
}

const Dashboard = ({
  data: websiteList,
  response: analyticData,
  refetch,
}: DashboardProps) => {
  const renderList = (option: any[]) => {
    return option?.map((data) => ({ label: data.domain, value: data.id }));
  };

  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  const nowLang = i18n.language === "ru" ? timeDataRu : timeDataEn;

  const [websiteData, setWebsiteData] = useState<DataResponse | any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTime, setSelectedTime] = useState<any>(nowLang[0]);
  const [selectedSite, setSelectedSite] = useState<any>(
    renderList(websiteList?.data)[0]
  );

  const filteredData = websiteData.hits?.hits.filter(
    (item: any) =>
      item._source.challenge_id &&
      item._source.base_url === "http://api.scaptcha.com/api/v2/check_challenge"
  );

  const fetchWebisteInfo = async (id: any, days: any) => {
    setLoading(true);
    try {
      const response = await request({
        url:
          `api/v2/logs/project/?project_id=${id}` +
          (days ? `&days=${days}` : ""),
      });
      const { data } = response;
      setWebsiteData(data);
      setLoading(false);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWebisteInfo(selectedSite?.value, selectedTime?.value);
  }, [selectedSite?.value, selectedTime?.value]);

  const { t } = useTranslation();

  const placeholderSelect = t("analyticPageSelectPlaceholder");

  return (
    <Container>
      <TopContent>
        <SelectTime>
          <p>{t("analyticSiteChanger")}:</p>
          <Select
            className="website-titles"
            classNamePrefix="select"
            defaultValue={selectedSite}
            placeholder={placeholderSelect}
            onChange={(val) => setSelectedSite(val)}
            name="websites"
            options={renderList(websiteList.data)}
          />
          <p>{t("analyticPageTimeSelect")}:</p>
          <Select
            className="time-basic-single"
            classNamePrefix="select"
            defaultValue={selectedTime}
            placeholder={placeholderSelect}
            onChange={(val) => setSelectedTime(val)}
            name="time"
            options={nowLang}
          />
        </SelectTime>
      </TopContent>
      <ChartsContainer>
        {loading ? (
          <Loader />
        ) : (
          <>
            <FirstGroup filteredData={filteredData} />
            {pathname === "/analytic_pre_prod" ? (
              <ThirdGroup filteredData={filteredData} />
            ) : (
              <div></div>
            )}
            <SixthGroup filteredData={filteredData} />
          </>
        )}
      </ChartsContainer>
    </Container>
  );
};

export default Dashboard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ChartsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 35px;
`;

const SelectTime = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }

  .website-titles {
    @media screen and (max-width: 768px) {
      width: 260px;
    }
  }
  .time-basic-single {
    width: 25%;

    @media screen and (max-width: 768px) {
      width: 260px;
    }
  }
`;
